<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link>|
      <router-link to="/about">About</router-link>
    </div>-->
    <div
      id="header"
      :class="{ fixednav: scrolldown === true }"
      class="full-header clearfix"
      style="height: 75px;"
    >
      <div id="header-wrap" style="padding-top: 15px; padding-bottom: 30px;">
        <div class="container clearfix">
          <div
            id="primary-menu-trigger"
            class="navbarhidden big-show"
            @click="menuTrigger()"
          >
            <i class="icon-reorder"></i>
          </div>
          <div
            id="primary-menu-trigger"
            class="small-show"
            @click="menuTrigger()"
          >
            <i class="icon-reorder"></i>
          </div>

          <!-- Logo
          =============================================-->
          <div
            id="logo"
            class="big-show"
            style="padding: 1px; cursor:pointer;"
            @click="$router.push('/')"
          >
            <img
              :src="getApiPath('0efd425b-2ac4-49d6-bc97-2f90ae250093.jpg')"
              alt="W"
            /><!-- <img :src="getFullPath('shopLogo.png')" alt="" /> -->
          </div>
          <!-- <div id="logo2" class="small-show" style="padding: 1opx; cursor:pointer;" @click="$router.push('/')"  >
            
            <img :src="getApiPath('736fde42-082e-49d0-a1a8-460165a876ea.jpg')" alt="W" />
          </div> -->
          <!-- #logo end -->

          <!-- Primary Navigation
          =============================================-->
          <nav
            id="primary-menu"
            class="style-2 with-arrows"
            style="width: 90% !important;"
          >
            <div
              class="row search_row"
              style="width: 60%;"
              v-show="show_search"
            >
              <div class="col-lg-9 col-md-9 col-9">
                <input
                  ref="thesearch"
                  @keyup.enter="submitSearch()"
                  v-model="searchText"
                  style=""
                  placeholder=" หาชุดอะไรดีนะ ?"
                  class="form-control search-text"
                />
              </div>
              <div
                class="col-lg-3 col-md-3 col-3"
                style="padding-top: 15px; cursor: pointer; "
              >
                <div
                  @click="clearSearch()"
                  style="font-weight: bold; border-radius: 15px; border : 1px solid #e4e4e4; margin-bottom: 10px;"
                  :class="{ hh: show_search === 0 }"
                >
                  X
                </div>
              </div>
            </div>

            <ul
              :class="{ hh: show_search === 1 }"
              id="primary-dropdown-menu"
              style="font-family:supermarket !important; font-size:16px; width: 100% !important;"
            >
              <!-- <li
                class="mega-menu-title"
                :class="{ current: selected === 1 }"
                @click="hideMenu(1)"
              >
                <router-link to="/rental-list/SALE">SALE</router-link>
              </li>
              <li
                class="mega-menu-title"
                :class="{ current: selected === 2 }"
                @click="hideMenu(2)"
              >
                <router-link to="/rental-list/สินค้ามาใหม่"
                  >สินค้ามาใหม่</router-link
                >
              </li>
              <li
                class="mega-menu-title"
                :class="{ current: selected === 3 }"
                @click="hideMenu(3)"
              >
                <router-link to="/rental-list/สินค้ายอดนิยม"
                  >สินค้ายอดนิยม</router-link
                >
              </li>

              <li
                class="mega-menu-title mainnav-children"
                :class="{ current: selected === 4 }"
                @click="hideMenu(4)"
              >
                <router-link to="/rental-list/รวมชุดเช่าแบรนด์"
                  >รวมชุดเช่าแบรนด์</router-link
                >

                <ul class="mainnav-submenu ">
                  <li class="submenu-item">
                    <router-link to="/rental-list/Kanapot">Kanapot</router-link>
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Louisa Ballou"
                      >Louisa Ballou</router-link
                    >
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Rotate">Rotate</router-link>
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Sleeper">Sleeper</router-link>
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Meshki">Meshki</router-link>
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Vickteerut"
                      >Vickteerut</router-link
                    >
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Danup">Danup</router-link>
                  </li>
                </ul>
              </li> -->

              <li
                v-for="(main_item, main_wc_ind) in main_wc"
                :key="main_wc_ind"
                class="mega-menu-title mainnav-children"
                :class="{ current: selected === main_wc_ind }"
                @click="hideMenu(main_wc_ind)"
              >
                <router-link
                  :to="getMainRouterLink('/rental-list', main_item)"
                  >{{ main_item }}</router-link
                >

                <ul v-if="sub_wc[main_item]" class="mainnav-submenu ">
                  <li
                    class="submenu-item"
                    v-for="(sub_item, sub_wc_ind) in sub_wc[main_item]"
                    :key="sub_wc_ind"
                  >
                    <router-link
                      :to="
                        getSubRouterLink(
                          '/rental-list',
                          main_item,
                          sub_item
                        )
                      "
                      >{{ sub_item }}</router-link
                    >
                  </li>
                </ul>
              </li>

              <!-- <li
                class="mega-menu-title mainnav-children"
                :class="{ current: selected === 6 }"
                @click="hideMenu(6)"
              >
                <router-link to="/rental-list/รองเท้าแบรนด์"
                  >รองเท้า</router-link
                >
                <ul class="mainnav-submenu ">
                  <li class="submenu-item">
                    <router-link to="/rental-list/Fendi">Fendi</router-link>
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Dior">Dior</router-link>
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Prada">Prada</router-link>
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Mach%24Mach"
                      >Mach&#38;Mach</router-link
                    >
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Chanel">Chanel</router-link>
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Gucci">Gucci</router-link>
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Amina Muaddi"
                      >Amina Muaddi</router-link
                    >
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Louis Vuitton"
                      >Louis Vuitton</router-link
                    >
                  </li>
                </ul>
              </li>

              <li
                class="mega-menu-title mainnav-children"
                :class="{ current: selected === 7 }"
                @click="hideMenu(7)"
              >
                <router-link to="/rental-list/ชุดว่ายน้ำแบรนด์"
                  >ชุดว่ายน้ำ</router-link
                >
                <ul class="mainnav-submenu ">
                  <li class="submenu-item">
                    <router-link to="/rental-list/Alexandderwang"
                      >Alexandderwang</router-link
                    >
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Fendi by versace"
                      >Fendi by versace</router-link
                    >
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Fendi">Fendi</router-link>
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Emilio Pucci"
                      >Emilio Pucci</router-link
                    >
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Gucci">Gucci</router-link>
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Louis Vuitton"
                      >Louis Vuitton</router-link
                    >
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Missonimare"
                      >Missonimare</router-link
                    >
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Versace">Versace</router-link>
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Noire">Noire</router-link>
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/Balmain">Balmain</router-link>
                  </li>
                </ul>
              </li>

              <li
                class="mega-menu-title mainnav-children"
                :class="{ current: selected === 8 }"
                @click="hideMenu(8)"
              >
                <router-link to="/rental-list/โอกาสพิเศษ"
                  >โอกาสพิเศษ</router-link
                >

                <ul class="mainnav-submenu ">
                  <li class="submenu-item">
                    <router-link to="/rental-list/ชุดกริตเตอร์"
                      >ชุดกริตเตอร์</router-link
                    >
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/ชุดตรุษจีน"
                      >ชุดตรุษจีน</router-link
                    >
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/ชุดโทนสีแดง"
                      >ชุดโทนสีแดง</router-link
                    >
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/ชุดโทนชมพู"
                      >ชุดโทนชมพู</router-link
                    >
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/ชุดโทนสีฟ้า"
                      >ชุดโทนสีฟ้า</router-link
                    >
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/ชุดโทนสีขาว"
                      >ชุดโทนสีขาว</router-link
                    >
                  </li>
                  <li class="submenu-item">
                    <router-link to="/rental-list/ชุดทางการ"
                      >ชุดทางการ</router-link
                    >
                  </li>
                </ul>
              </li> -->

              <li
                class="mega-menu-title"
                :class="{ current: selected === 97 }"
                @click="hideMenu(97)"
              >
                <router-link to="/howtorent">วิธีเช่า</router-link>
              </li>
              <li
                class="mega-menu-title"
                :class="{ current: selected === 98 }"
                @click="hideMenu(98)"
              >
                <router-link to="/faq">FAQ</router-link>
              </li>
              <!-- <li class="mega-menu-title" :class="{current: selected === 9}" @click="hideMenu(9)">
                <router-link to="/blog">Blog</router-link>
              </li>-->
              <li
                class="mega-menu-title"
                :class="{ current: selected === 99 }"
                @click="hideMenu(99)"
              >
                <router-link to="/contact-us">ติดต่อเรา</router-link>
              </li>

              <li class="mega-menu-title">
                <i
                  @click="showSearch()"
                  style="font-size:16px; padding: 15px 13px;cursor: pointer;"
                  class="icon-search3"
                ></i>
              </li>
              <li class="mega-menu-title">
                <router-link to="/cart">
                  <i
                    style="font-size: 32px; color: #a7a7a7; "
                    class="icon-shopping-basket"
                  ></i>
                  <div
                    v-if="$store.state.listnumber > 0"
                    style="position: absolute; top: 60%; left: 70%; ;width: 20px; height:20px; border-radius: 15px; background-color: red; color: white; font-size: 9px;"
                  >
                    {{ $store.state.listnumber }}
                  </div>
                </router-link>
              </li>
            </ul>
          </nav>
          <!-- #primary-menu end -->
        </div>
      </div>
    </div>
    <router-view />
    <ft></ft>
  </div>
</template>
<script>
import store from "@/store.js";
import Ft from "@/views/Ft.vue";

import myMixins from "@/mixins/myMixins.js";
import axios from "axios";

export default {
  mixins: [myMixins],
  data() {
    return {
      searchText: "",
      show_search: 0,
      scrolldown: false,
      selected: 0,
      showNavbar: true,
      lastScrollPosition: 0,
      webCategory: [],
      main_wc: [],
      sub_wc: [],
    };
  },

  mounted() {
    // window.addEventListener("scroll", this.onScroll);

    var it = JSON.parse(localStorage.getItem("rentalitem"));
    if (it !== null && it !== undefined) {
      store.state.listnumber = it.length;
    } else {
      store.state.listnumber = 0;
    }

    // var x = window.scrollX;
    // var y = window.scrollY;
    // document.getElementById("demo").innerHTML =
    //   "Horizontally: " + x + "px<br>Vertically: " + y + "px";
  },
  beforeDestroy() {
    // window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("scroll", this.handleScroll);
  },
  async created() {
    window.addEventListener("scroll", this.handleScroll);
    await this.getWebCategory();
  },

  methods: {
    async getWebCategory() {
      var api_url = store.state.apiUrl + "/web-api/web/all-list";

      var response = await axios.post(api_url, {}, store.state.apiHeader);
      var all = response.data;

      this.webCategory = all.webCategories;

      this.main_wc = [];
      this.sub_wc = [];

      for (let mi = 0; mi < this.webCategory.length; mi++) {
        const wc = this.webCategory[mi];
        const wc_desc = wc.description;
        let spt = wc_desc.split(".");

        if (spt.length >= 2) {
          if (
            this.sub_wc[spt[0]] === null ||
            this.sub_wc[spt[0]] === undefined
          ) {
            this.sub_wc[spt[0]] = [];
          }
          this.sub_wc[spt[0]].push(spt[1]);
        } else {
          this.main_wc.push(wc_desc);
        }
      }

      // console.log("this.sub_wc ", this.sub_wc);
      // console.log("this.main_wc ", this.main_wc);
    },

    getSubRouterLink(prefix, main_menu, sub_menu) {
      return prefix + "/" + main_menu + "." + sub_menu;
    },
    getMainRouterLink(prefix, main_menu) {
      return prefix + "/" + main_menu;
    },

    clearSearch() {
      this.searchText = "";
      this.show_search = 0;
    },
    submitSearch() {
      if (this.$route.params.searchtext !== this.searchText) {
        return this.$router.push("/search/" + this.searchText);
      }
    },
    showSearch() {
      this.show_search = 1;
      this.$nextTick(() => this.$refs.thesearch.focus());
    },
    hantai() {
      return !this.show_search;
    },
    handleScroll() {
      this.scrolled = window.scrollY > 0;
      if (window.scrollY > 60) {
        this.scrolldown = true;
      } else {
        this.scrolldown = false;
      }
    },
    onScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      if (currentScrollPosition < 0) {
        return;
      }
      // Stop executing this function if the difference between
      // current scroll position and last scroll position is less than some offset
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
        return;
      }
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      this.lastScrollPosition = currentScrollPosition;
    },
    hideMenu(num) {
      this.selected = num;
      var primaryDropdownMenu = document.getElementById(
        "primary-dropdown-menu"
      );
      if (this.detectmob()) {
        primaryDropdownMenu.style.display = "none";
      }
    },
    menuTrigger() {
      var primaryDropdownMenu = document.getElementById(
        "primary-dropdown-menu"
      );

      if (
        primaryDropdownMenu.style.display === "none" ||
        primaryDropdownMenu.style.display === null ||
        primaryDropdownMenu.style.display === undefined ||
        primaryDropdownMenu.style.display === ""
      ) {
        primaryDropdownMenu.style.display = "block";
      } else {
        primaryDropdownMenu.style.display = "none";
      }
    },
    getFullPath(mainImage) {
      if (mainImage === undefined || mainImage === null || mainImage === "") {
        return store.state.imageUrl + "defaultimage.png";
      } else {
        return store.state.imageUrl + mainImage;
      }
    },
  },
  components: {
    Ft,
  },
};
</script>
<style lang="scss">
a {
  text-decoration: none;

  &:hover {
    color: #3ca0e7;
  }
}

ul li ul li a {
  transition: all 0.5s ease;
}

.search-text {
  font-family: "mitr-regular" !important;
  padding-left: 30px;
  width: 75%;
  border: 0 white solid;
  padding-top: 5px;
  margin-right: 10px;
  font-size: 1.3rem;
}

li.mega-menu-title a {
  font-size: 1rem !important;
}

@media only screen and (min-width: 1200px) {
  .container {
    max-width: 1200px;
  }
}
@media only screen and (min-width: 800px) {
  .small-show {
    display: none !important;
  }
  .big-show {
    display: block;
  }
}
@media only screen and (max-width: 800px) {
  .search-text {
    font-size: 0.9rem !important;
    font-family: "mitr-regular" !important;
    width: 100% !important;
  }
  .search_row {
    width: 100% !important;
  }
  #logo img {
    padding-top: 20px;
    margin-left: 30px;
    height: 70px !important;
  }

  .small-show {
    display: inline-block !important;
  }
  .big-show {
    display: none;
  }
  .style-2 {
    width: 100% !important;
  }


  #primary-dropdown-menu {
    position: fixed;  // ทำให้เมนูยึดกับหน้าจอ
    top: 100px;  // เลื่อนลงมาเพื่อไม่ให้ทับกับ header (กำหนดให้ตรงกับความสูงของ header)
    left: 0;
    right: 0;
    height: calc(100vh - 100px); // กำหนดความสูงของเมนูให้ยาวจนถึงขอบล่างของหน้าจอ (ลบความสูง header)
    overflow-y: auto;  // เปิดการ scroll ในกรณีที่เนื้อหาเมนูล้นหน้าจอ
    background-color: white;  // กำหนดพื้นหลังเพื่อให้แยกจากเนื้อหาอื่นๆ
    z-index: 99999; // ให้แน่ใจว่าเมนูอยู่ด้านบนขององค์ประกอบอื่น
    padding-left: 30px !important;
    padding-right: 30px !important;
    width: 100%;
    background-color: white;
  }

  .mainnav-submenu {
    display: block !important;  // แสดงผลในรูปแบบ block เสมอ
    padding: 10px;
    max-height: calc(100vh - 150px); // จำกัดความสูงของ submenu ไม่ให้สูงเกินขอบล่างของหน้าจอ
    overflow-y: auto;  // เปิดการ scroll ในกรณีที่ submenu ล้น
    z-index: 99999 !important;
    padding-left:  30px;
  }
  #primary-menu ul > li{
    padding-left: 30px
  }


  //.mainnav-submenu {
  //  display: none;
  //  left: 12px !important;
   // width: 170px !important;
  //  z-index: 99999 !important;
  //  height: 200px !important;
  //  overflow-x: hidden !important;
  //  overflow-y: scroll !important;
  //}

  //#primary-dropdown-menu {
  //  // display: block;
  //  padding-bottom: 20px !important;
  //  overflow-y: scroll !important;
  //}

  //   .mainnav-children:hover .mainnav-submenu {
  //   display: block !important;
  //   padding: 10px;
  //   z-index: 99999 !important;

  //   height: 200px !important;
  //   overflow-x: hidden;
  //   overflow-y: scroll;
  // }
}

@media only screen and (min-width: 900px) {
  #primary-menu {
    display: inline-block !important;
  }
  .search_row {
    width: 100% !important;
  }
  #primary-dropdown-menu {
    display: block;
  }
}
#app {
  font-family: "Mitr", "supermarket", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.navbarhidden {
  box-shadow: none;
  transform: translate3d(0, -100%, 0);
}

.fixednav {
  position: fixed !important;
  z-index: 99999 !important;
  background-color: #fff;
  border-bottom: 1px solid #f5f5f5;
  margin: 0 auto !important;
  width: 100%;
  top: 0;
}

.hh {
  display: none !important;
}

/*** FOR DROPDOWN MENU */
.page-menu-item a {
  color: #565656 !important;
  background-color: white !important;
  text-align: left !important;
}
.page-menu-item a:hover {
  background-color: #ddd !important;
}

.button:hover {
  background-color: #e9e9e9 !important;
  color: #565656 !important;
  border: 1px solid black !important;
}

.button:active {
  background-color: black !important;
  color: white !important;
  border: 1px solid black !important;
}

#page-menu ul ul {
  background-color: white !important;
}
.page-menu-sub-menu {
  background-color: white !important;
}

.mainnav-submenu {
  display: none;
  left: 12px !important;
  width: 170px !important;
  z-index: 99999 !important;
  // height: 200px !important;
  // overflow-x: hidden;
  // overflow-y: scroll;
}

.mainnav-children:hover .mainnav-submenu {
  display: block !important;
  padding: 10px;
  z-index: 99999 !important;

  // height: 200px !important;
  // overflow-x: hidden;
  // overflow-y: scroll;
}

.submenu-item {
  // padding: 5px 10px;
  text-align: left !important;
  cursor: pointer;
  font-family: mitr;
  font-size: 0.8rem;
}

.submenu-item:hover a {
  // background-color: #e1e1e1;
  color: #e94b35 !important;
}

.hooper-prev {
  display: none;
}

.hooper-next {
  display: none;
}

.hooper-pagination {
  display: none;
}

/*** FOR DROPDOWN MENU */
</style>